<template>
  <div>
    <Nav
      current="我的"
      ref="child"
      :switchboardIdentity="switchboardIdentity"
    ></Nav>
    <div class="content">
      <div class="title">基础信息</div>
      <div class="form">
        <div class="form_item">
          <span class="item_name">名称</span>
          <!-- <input type="text" class="inputs" v-model="info.name" disabled /> -->
          <input type="text" class="inputs" v-model="info.switchboard_identity_name_show" disabled />
        </div>
        <div class="form_item">
          <span class="item_name">登录账号</span>
          <input type="text" class="inputs" v-model="info.login" disabled />
        </div>
        <div class="form_item">
          <span class="item_name">当前子系统</span>
          <input
            type="text"
            class="inputs"
            v-model="info.businessSystemName"
            disabled
          />
        </div>
      </div>
      <div class="title">切换系统</div>
      <div class="form">
        <div class="form_item">
          <span class="item_name">系统名称</span>
          <el-select class="el-select--hnc" v-model="osUrl" @change="switchSystem">
            <el-option
              v-for="item in systemList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="title">设置</div>
      <div class="form">
        <div class="form_item">
          <span class="item_name">密码设置</span>
          <el-button type="hnc" style="width: 200px; height: 30px;line-height: 0.5;" @click="toModifyPwd">修改密码</el-button>
        </div>
      </div>
    </div>

    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync='visible' :showDialog="visible" :title='title' v-dialogDrag width="460px">
      <Password @changeShowDialog="changeShowDialog" :mobile="info.login"></Password>
    </el-dialog>
  </div>
</template>
<script>
import Nav from "@/components/Nav.vue";
import Password from "@/components/web/Password.vue";
import apiData from "@/config/api";
import http from "@/config/httpConfig";
export default {
  components: {
    Nav,
    Password
  },
  data() {
    return {
      title: '',
      visible: false,//是否显示修改密码
      txt: "我的",
      info: "",
      switchboardIdentity: {
        switchboard_identity_name: "", //编号
        switchboard_identity_alias: "", //姓名
      },
      systemList: [],
      osUrl: "",
      sysTemName: "213",
    };
  },
  created() {
    let route = this.$route;
    if (route.query && route.query.switchboard_identity_id) {
      document.cookie = `_login_switchboard_identity_id=${route.query.switchboard_identity_id}; path=/`;
    }
  },
  mounted() {
    this.getSystemList();
    console.log(this.osUrl, 123);
    let route = this.$route;
    if (route.query && route.query.switchboard_identity_id) {
      this.getList({
        switchboard_identity_id: route.query.switchboard_identity_id,
      });
    } else {
      this.getList();
    }
  },
  methods: {
    changeShowDialog(flag) {
      this.visible = flag
    },
    //
    toModifyPwd() {
      this.visible = true
    },
    getCookie(name) {
      var arr,
        reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
      if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
      else return null;
    },
    getList(params) {
      let _this = this;
      let flag = true;
      http.get(apiData.switchboardIdentityChange, true, params, function (res) {
        if (res.data.code == 200) {
            // 000新增基础信息里面的名称
            let resultData = res.data.data
            if(resultData){
                if(resultData.switchboard_identity_type == 3){
                    if(resultData.switchboard_identity_alias && resultData.switchboard_identity_name){
                        resultData.switchboard_identity_name_show = resultData.switchboard_identity_name + "/" + resultData.switchboard_identity_alias
                    }else if(!resultData.switchboard_identity_alias && resultData.switchboard_identity_name){
                        resultData.switchboard_identity_name_show = resultData.switchboard_identity_name
                    }else if(resultData.switchboard_identity_alias && !resultData.switchboard_identity_name){
                        resultData.switchboard_identity_name_show = resultData.switchboard_identity_alias
                    }else{
                        resultData.switchboard_identity_name_show = ""
                    }
                }else{
                    resultData.switchboard_identity_name_show = resultData.switchboard_identity_name
                }
            }
          _this.info = res.data.data;
          //加载时获取系统id
          _this.osUrl = res.data.data.businessSystemId
          console.log(res.data.data);
          if (_this.$route.query.switchboard_identity_id) {
            _this.$refs.child.getListMenu(flag);
          }
          _this.switchboardIdentity = res.data.data;
          localStorage.setItem(
            "switchboardIdentity",
            JSON.stringify(res.data.data)
          );
        } else {
        }
      });
    },
    // 切换系统
    switchSystem() {
      let _this = this;
      // console.log(_this.osUrl)
      var url = "";
      for (let i = 0; i < _this.systemList.length; i++) {
        if (_this.systemList[i].id == _this.osUrl) {
          _this.osUrl = _this.systemList[i].id;
          console.log(_this.osUrl);
          // url =d
          window.location.href = apiData.tapSystem+'?businessSystemId='+_this.systemList[i].id
          break;
        }
      }
    },
    // 获取系统集合
    getSystemList() {
      let _this = this;
      http.get(apiData.systemList, true, {}, function (res) {
        if (res.data.code == 200 && res.data.data.list) {
          _this.systemList = res.data.data.list;
          localStorage.setItem("systemList", JSON.stringify(res.data.data.list));
        }
        // console.log(_this.systemList,'0000')
        // console.log(_this.sysTemName)
      });
    },
  },
};
</script>

<style scoped lang="less">
.content {
  text-align: left;

  .title {
    width: 100%;
    height: 56px;
    line-height: 56px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    text-indent: 10px;
  }

  .form {
    .form_item {
      display: flex;
      width: 100%;
      height: 40px;
      line-height: 40px;
      text-indent: 10px;

      input {
        height: 30px;
        margin-top: 5px;

        background: #ccc;
        border: 1px solid rgb(204, 204, 204);
        text-indent: 10px;
      }

      .xing {
        color: #ffba1a;
      }

      .indent {
        padding-left: 10px;
      }
    }

    .item_name {
      width: 160px;
      display: block;
      color: #666;
    }

    .form_item:nth-child(odd) {
      background: #f8f8f8;
    }
  }
  
}
/deep/
.el-dialog {
  border-radius: 8px;
}
// .el-row {
//   text-align: center;
//   height: 40px;
//   width: 100%;
//   margin: 200px 0;
// }

// .btnret:hover {
//   background: #55c4b8;
//   border: 1px solid #55c4b8;
//   color: #f8f8f8;
// }

// // .el-button {
// //   width: 200px;
// //   height: 40px;
// //   border: 1px solid #55c4b8;
// //   color: #55c4b8;
// // }
.el-button--hnc {
  margin-top: 5px;
}
// .btnSty {
//   background: #55c4b8;
//   color: #fff;
// }

// .btnSty:hover {
//   background: #55c4b8;
//   color: #fff;
//   border: 1px solid #55c4b8;
// }
</style>